/* // document.addEventListener('DOMContentLoaded', function() {
  $('body').find('.collection-dropdown').select2({
    placeholder: "Click to scroll or begin typing",
    allowClear: true
  });
// }); */

if ($('body').find('.collection-dropdown').length > 0) {
  $('.collection-dropdown').select2({
    placeholder: 'Select a collection',
    allowClear: true
  });
}

$('#collection-list').on('select2:select', function(e) {
  const selectedUrl = e.params.data.id;
  if (selectedUrl) {
    window.location.href = selectedUrl;
  }
});

$(document).ready(function(){
  if (window.location.pathname === "/apps/request-a-quote/index") {
    console.log('quote form');
    const matches = JSON.parse(localStorage.getItem("pump_matches")); 
    console.log('matches: ', matches);
    
    if (matches) {
       $('input[name="storeifyInput_first_name"]').val(matches.firstname);
      $('input[name="storeifyInput_last_name"]').val(matches.lastname);
      $('input[name="storeifyInput_email"]').val(matches.email); 
    }
    
    if (matches.submitted == 'products-page-submitted') {
      $(".user-chemical-name").val(matches.chem);
      $(".pump-search-result").closest("div.storeify-frm-group").hide();

      // Check the "Know more details about Pump?" checkbox
      $(".know-more-checkbox").prop("checked", true).trigger("change");
    } else {
      $(".user-chemical-name").val(matches.chem);
      $(".user-chemical-name").closest("div.storeify-frm-group").hide();

       // Check the "Know more details about Pump?" checkbox
      $(".know-more-checkbox").prop("checked", false).trigger("change");
      
      const best = [];
      const good = [];
      const caution = [];
      const fair = [];
  
      for (let row = 0; row < 5; row++) {
        if (matches.results[row]?.isbest) best.push(row);
        if (matches.results[row]?.isgood) good.push(row);
        if (matches.results[row]?.isfair) fair.push(row);
        if (matches.results[row]?.caution) caution.push(row);
      }
  
      // Start HTML generation
      let html = `<div class="cookie-alert based-search-result">Based on your most recent search for <strong>${matches.chem}:</strong><br>`;
  
      if (best.length > 0) {
        html += `<p><strong>Your Best Match(es):</strong>`;
        best.forEach(index => {
          html += `<br><a href="${matches.results[index].url}/?goodsearch=true" target="_blank">${matches.results[index].name}</a>`;
        });
        html += `</p>`;
      } else {
        html += `<p>You did not have any ‘Best Pump’ recommendations.<br>`;
        if (good.length > 0) {
          html += `<strong>Your Good Match(es):</strong>`;
          good.forEach(index => {
            html += `<br><a href="${matches.results[index].url}/?goodsearch=true" target="_blank">${matches.results[index].name}</a>`;
          });
        }
        if (fair.length > 0) {
          html += `<br><strong>Your Fair Match(es):</strong>`;
          fair.forEach(index => {
            html += `<br><a href="${matches.results[index].url}/?goodsearch=true" target="_blank">${matches.results[index].name}</a>`;
          });
        }
        html += `</p>`;
      }
  
      // Hose info
      if (matches.hose1) {
        html += `Hose(s): <strong>${matches.hose1}</strong>`;
      }
      if (matches.hose2) {
        html += ` or <strong>${matches.hose2}</strong>.`;
      }
  
      // Notes
      if (matches.notes) {
        html += `<br>Important notes: <strong>${matches.notes}</strong>.`;
      }
  
      // Flammable note
      if (matches.flammable) {
        html += `<br><em>${matches.chem} is ${matches.flammable}.</em>`;
      }
      html += `</div>`;
  
      // Append HTML to the desired container
      $('.pump-search-result').append(html); // Change 'body' to specific container if needed
    }

    function checkIfQuoteTableIsEmpty() {
      // Count the product rows
      var productCount = $('.list_product_quote').length;

      // If no products left, remove localStorage item
      if (productCount === 0) {
        localStorage.removeItem('pump_matches');
        console.log('All products removed, pump_matches cleared from localStorage.');
      }
    }

    // Run once on page load
    checkIfQuoteTableIsEmpty();
      console.log("Test")
    // Observe DOM changes using MutationObserver
    var target = $('table.storeify-table-product tbody')[0];

    if (target) {
      var observer = new MutationObserver(function () {
        checkIfQuoteTableIsEmpty();
      });

      observer.observe(target, {
        childList: true, // listen for row add/remove
      });
    }

    // Update the text with links
    var $scp_input = $('.scp-series-pump');
    console.log("Hello2 ")
    if ($scp_input.length > 0) {
      console.log("Hello ")
      // Traverse to the closest .storeify-frm-group parent and find the .storeify-notes element
      var $note = $scp_input.closest('.storeify-frm-group').find('.storeify-notes');
  
      // Replace "SCP-series Pump" text with a hyperlink
      var html = $note.html();
      var updatedHtml = html.replace(
        /SCP-series Pump./,
        '<a href="https://cdn.shopify.com/s/files/1/0697/9066/2821/files/Safety-and-Technical_Info_SCP-6500.pdf?v=1744264725" target="_blank">SCP-series Pump</a>'
      );
      $note.html(updatedHtml);
    }

    var $moreinfo_input = $('.deliver-the-fluids');
    if ($moreinfo_input.length > 0) {
      console.log("Hello ")
      // Traverse to the closest .storeify-frm-group parent and find the .storeify-notes element
      var $note = $moreinfo_input.closest('.storeify-frm-group').find('.storeify-notes');
  
      // Replace "SCP-series Pump" text with a hyperlink
      var html = $note.html();
      var updatedHtml = html.replace(
        /More Info/,
        '<a href="https://cdn.shopify.com/s/files/1/0697/9066/2821/files/Remote-Tap-Instruction-options.pdf?v=1744803216" target="_blank">More Info</a>'
      );
      $note.html(updatedHtml);
    }

    var $bga_input = $('.bga-pneumatic-adapter');
    if ($bga_input.length > 0) {
      console.log("Hello ")
      // Traverse to the closest .storeify-frm-group parent and find the .storeify-notes element
      var $note = $bga_input.closest('.storeify-frm-group').find('.storeify-notes');
  
      // Replace "SCP-series Pump" text with a hyperlink
      var html = $note.html();
      var updatedHtml = html.replace(
        /See Adapters/,
        '<a href="https://goatthroat.com/collections/air-operated-pneumatic-line" target="_blank">See Adapters</a>'
      );
      $note.html(updatedHtml);
    }

    var $pumplisting_input = $('.pump-listing');
    if ($pumplisting_input.length > 0) {
      console.log("Hello ")
      // Traverse to the closest .storeify-frm-group parent and find the .storeify-notes element
      var $note = $pumplisting_input.closest('.storeify-frm-group').find('.storeify-notes');
  
      // Replace "SCP-series Pump" text with a hyperlink
      var html = $note.html();
      var updatedHtml = html.replace(
        /Chemical Compatibility Guide/,
        '<a href="https://goatthroat.com/pages/complete-chemical-liquid-compatibility-guide" target="_blank">Chemical Compatibility Guides</a>'
      );
      $note.html(updatedHtml);
    }

    var $terms_checkbox = $('.terms-checkbox');
    if ($terms_checkbox.length > 0) {
    
      // Traverse to the closest .storeify-frm-group parent and find the .storeify-notes element
      var $note = $terms_checkbox.closest('.storeify-frm-group').find('.storeify-notes');
      $terms_checkbox.closest('.storeify-frm-group').addClass("term-service-section")
  
      // Replace "SCP-series Pump" text with a hyperlink
      var html = $note.html();
      var updatedHtml = html.replace(
        /Terms and Conditions/,
        '<a href="https://goatthroat.com/policies/terms-of-service" target="_blank">Terms and Conditions</a>'
      );
      $note.html(updatedHtml);
    }

    // --- Start of new code for checkbox visibility ---

    const $knowMoreCheckbox = $('.know-more-checkbox');
    const $fieldsToToggle = $knowMoreCheckbox.closest('.storeify-frm-group').nextAll().not('.storeifyInput_aa62c2185940_8347_group, .storeifyInput_01fe8d67400e_8347_group');
    const $containerInfoSection = $('.storeifyInput_aa62c2185940_8347_group');
    const $accessoriesSection = $('.storeifyInput_01fe8d67400e_8347_group');
    const $allAffectedFields = $knowMoreCheckbox.closest('.storeify-frm-group').nextAll().not('.term-service-section');
  
    function toggleFieldsVisibility() {
      if ($knowMoreCheckbox.is(':checked')) {
        $allAffectedFields.show();
        $(".pump-search-result").closest("div.storeify-frm-group").hide();
      } else {
        $allAffectedFields.hide();
      }
    }
  
    // Initial state on page load
    toggleFieldsVisibility();
  
    // Attach change event listener to the checkbox
    $knowMoreCheckbox.on('change', function() {
      toggleFieldsVisibility();
    });
  
    // --- End of new code for checkbox visibility ---

    /* START: code to hide N/A from textbox input field */
    var $submitBtn = $('.storeify-submit-frm');

    // Handle both input and textarea
    var $fields = $('#storeifyInput_977adbb6f45c_8347, #storeifyInput_f2cf2b8e4c3b_8347');

    $fields.each(function() {
      var $field = $(this);
      $field.data('default', $field.val());
      $field.val(''); // Hide default value visually
    });

    $submitBtn.on('click', function() {
      $fields.each(function() {
        var $field = $(this);
        if ($.trim($field.val()) === '') {
          $field.val($field.data('default') || 'N/A');
        }
      });
    });
    /* END: code to hide N/A from textbox input field */

    var $checkboxGroup = $('.chemical-consistency');
    var $naCheckbox = $('#storeifyInput_ef4ffeed5377_5'); // This is the N/A checkbox

    function updateNACheckbox() {
      // Get all checkboxes except N/A
      var $otherCheckboxes = $checkboxGroup.not($naCheckbox);

      // If any other checkbox is checked, uncheck N/A
      if ($otherCheckboxes.is(':checked')) {
        $naCheckbox.prop('checked', false);
      } else {
        $naCheckbox.prop('checked', true);
      }
    }

    // Attach change event to all checkboxes
    $checkboxGroup.on('change', function() {
      updateNACheckbox();
    });

    // Run once on page load in case defaults are different
    updateNACheckbox();
  }
  
  if (window.location.href.includes('/products/')) {
    $(document).on('click', '.storeify-quote-btn-trigger-popup', function (e) {
      // Get the value of the chemical input field
      var chemicalName = $('#what-chemical-are-you-planning-on-using').val() || '';
      // If chemical is entered, save to localStorage
      // if (chemicalName.trim() !== '') {
        let existing = localStorage.getItem('pump_matches');
        let matches;

        if (existing) {
          // Parse and update only the necessary fields
          matches = JSON.parse(existing);

          // Convert to array and check if new chem already exists,
          let chemList = matches.chem ? matches.chem.split(',').map(c => c.trim()) : [];
  
          if (!chemList.includes(chemicalName.trim())) {
            chemList.push(chemicalName.trim());
          }
  
          matches.chem = chemList.join(', ');
          matches.submitted = 'products-page-submitted';
        } else {
          // Create new object if not present
          matches = {
            chem: chemicalName.trim(),
            firstname: '',
            lastname: '',
            email: '',
            submitted: 'products-page-submitted',
            results: []
          };
        }
  
        // Save back to localStorage
        localStorage.setItem('pump_matches', JSON.stringify(matches));
        console.log('Saved pump_matches:', matches);
      // }
    });
  }
});